import React from 'react';

const QUESTION_TYPES = ['text', 'checkbox', 'radio', 'select', 'textarea'];

export const QuestionnaireAdminQuestionModal = ({
  isOpen,
  mode,
  questionForm,
  setQuestionForm,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) {
    return null;
  }

  const isEdit = mode === 'edit';
  const prefix = isEdit ? 'edit' : 'add';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid={`questionnaire-admin-${prefix}-question-modal-overlay`}>
      <div className="bg-white rounded-2xl w-full max-w-lg p-6 max-h-[90vh] overflow-y-auto" data-testid={`questionnaire-admin-${prefix}-question-modal`}>
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-testid={`questionnaire-admin-${prefix}-question-title`}>
          {isEdit ? 'Editar Pergunta' : 'Nova Pergunta'}
        </h3>
        <form onSubmit={onSubmit} className="space-y-4" data-testid={`questionnaire-admin-${prefix}-question-form`}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
              <select
                value={questionForm.type}
                onChange={(event) => setQuestionForm({ ...questionForm, type: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                data-testid={`questionnaire-admin-${prefix}-question-type-select`}
              >
                {QUESTION_TYPES.map((type) => (
                  <option key={type} value={type}>
                    {type === 'text' ? 'Texto' : type === 'checkbox' ? 'Checkbox' : type === 'radio' ? 'Radio' : type === 'select' ? 'Select' : 'Textarea'}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={questionForm.required}
                  onChange={(event) => setQuestionForm({ ...questionForm, required: event.target.checked })}
                  className="w-5 h-5 text-green-600 rounded"
                  data-testid={`questionnaire-admin-${prefix}-question-required-checkbox`}
                />
                <span className="text-sm font-medium text-gray-700">Obrigatório</span>
              </label>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Texto (Japonês)</label>
            <input
              type="text"
              value={questionForm.text_jp}
              onChange={(event) => setQuestionForm({ ...questionForm, text_jp: event.target.value })}
              className="w-full px-4 py-2 border rounded-lg"
              placeholder="日本語テキスト"
              data-testid={`questionnaire-admin-${prefix}-question-text-jp-input`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Texto (Português) *</label>
            <input
              type="text"
              value={questionForm.text_br}
              onChange={(event) => setQuestionForm({ ...questionForm, text_br: event.target.value })}
              required
              className="w-full px-4 py-2 border rounded-lg"
              placeholder="Texto em português"
              data-testid={`questionnaire-admin-${prefix}-question-text-br-input`}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Texto (Inglês)</label>
              <input
                type="text"
                value={questionForm.text_us}
                onChange={(event) => setQuestionForm({ ...questionForm, text_us: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="English text"
                data-testid={`questionnaire-admin-${prefix}-question-text-us-input`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Texto (Espanhol)</label>
              <input
                type="text"
                value={questionForm.text_es}
                onChange={(event) => setQuestionForm({ ...questionForm, text_es: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="Texto en español"
                data-testid={`questionnaire-admin-${prefix}-question-text-es-input`}
              />
            </div>
          </div>

          {['checkbox', 'radio', 'select'].includes(questionForm.type) && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Opções (separadas por vírgula)</label>
              <textarea
                value={questionForm.options}
                onChange={(event) => setQuestionForm({ ...questionForm, options: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg"
                rows={3}
                placeholder="Opção 1, Opção 2, Opção 3"
                data-testid={`questionnaire-admin-${prefix}-question-options-textarea`}
              />
            </div>
          )}

          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 py-2 border rounded-lg" data-testid={`questionnaire-admin-${prefix}-question-cancel-button`}>
              Cancelar
            </button>
            <button type="submit" className={`flex-1 py-2 ${isEdit ? 'bg-blue-600' : 'bg-green-600'} text-white rounded-lg`} data-testid={`questionnaire-admin-${prefix}-question-submit-button`}>
              {isEdit ? 'Salvar' : 'Adicionar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
